<template>
    <div>
        <div>
            <div class="row mb-3">
                <div class="col-lg-3">
                    <div class="mt-4 mt-lg-0">
                        <h4 class="card-title">Unit #</h4>
                        <v-select :options="activeUnits" :reduce="unit => unit.UID" label="name" v-model="searchUnit" multiple style="background-color: #fff;"></v-select>
                    </div>
                </div>
                <div class="col-lg-3">
                    <h4 class="card-title">Start Date</h4>
                    <date-picker v-model="searchStartDate" :first-day-of-week="1" lang="en"></date-picker>
                </div>
                <div class="col-lg-3">
                    <h4 class="card-title">End Date</h4>
                    <date-picker v-model="searchEndDate" :first-day-of-week="1" lang="en"></date-picker>
                </div>
                <div class="col-lg-3">
                    <div class="mt-4 mt-lg-0">
                        <h4 class="card-title">
                            Deep Search <i id="deep_search_help" class="bx bxs-help-circle"></i>
                        </h4>
                        <b-tooltip target="deep_search_help" placement="top" :fallback-placement="[]" container="body" custom-class="deep-search-tip">
                            This will return all workorders and repairs that at least partially include
                            the entered search value. You can enter document names, issues, work order numbers, etc.
                        </b-tooltip>
                        <b-form-input label="name" v-model="searchKeywords" v-on:keyup.enter="search()"></b-form-input>
                    </div>
                </div>
            </div>
            <!-- end row -->

            <div class="row mt-4">
                <div class="col-lg-3">
                    <div class="mt-4 mt-lg-0">
                        <h4 class="card-title">Repairs Complete</h4>
                        <v-select
                            :options="[{ label: 'Repairs Complete', value: true }, { label: 'Repairs Ongoing', value: null }, { label: 'Repairs Incomplete', value: false }]"
                            v-model="searchRepairsComplete" style="background-color: #fff;"></v-select>
                    </div>
                </div>
                <div class="col-lg-3">
                    <div class="mt-4 mt-lg-0">
                        <h4 class="card-title">Document Status</h4>
                        <v-select
                            :options="[{ label: 'All Documents Received', value: true }, { label: 'Waiting For Documents', value: null }, { label: 'No Documents Required', value: false }]"
                            v-model="searchDocumentStatus" style="background-color: #fff;"></v-select>
                    </div>
                </div>
                <div class="col-lg-3">
                    <div class="mt-4 mt-lg-0">
                        <h4 class="card-title">Approval/Submission Status</h4>
                        <v-select
                            :options="[{ label: 'Approved', value: true }, { label: 'Awaiting Review', value: null }, { label: 'Resubmitted for Review', value: null }, { label: 'Changes Requested', value: false }, { label: 'Not Submitted', value: false }]"
                            v-model="searchRepairsApproved" style="background-color: #fff;"></v-select>
                    </div>
                </div>
                <div class="col-3 mt-4">
                    <div class="d-flex justify-content-center">
                        <div class="mr-4">
                            <b-button v-if="searchLoading === false" style="min-width: 7rem;" id="btn_search"
                                variant="primary" v-on:click="search()" class="btn btn-label btn-primary">
                                <i class="bx bx-search label-icon"></i>
                                Search
                            </b-button>
                            <b-button v-else variant="primary" style="min-width: 7rem;"
                                class="btn btn-primary d-flex justify-content-center">
                                <spring-spinner :animation-duration="3000" :size="20" :color="'white'" />
                            </b-button>
                        </div>
                        <div>
                            <b-button style="min-width: 7rem;" id="btn_search" variant="primary" v-on:click="clearSearch()"
                                class="btn btn-label btn-primary">
                                <i class="bx bx-reset label-icon"></i>
                                Reset
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- end row -->

            <div class="row float-right">

            </div>
            <!-- en row -->
        </div>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import { SpringSpinner } from 'epic-spinners';
import lodash from 'lodash'
import { firestore } from 'firebase';
import { getWorkOrderRepairsWithConditions, getWorkOrdersWithConditions } from '../../../helper/dbHelpers';

export default {
    components: {
        DatePicker,
        SpringSpinner,
    },
    props: {
        units: Array,
    },
    data() {
        return {
            searchEndDate: null,
            searchKeywords: null,
            searchStartDate: null,
            searchUnit: null,
            searchLoading: false,
            searchRepairsComplete: null,
            searchDocumentStatus: null,
            searchRepairsApproved: null
        };
    },
    methods: {
        search() {
            this.searchLoading = true;
            // this search method maps through each workorder, for each workorder it manually checks if the workorder matches the set filters (if any are set)
            // if the workorder passes the filter checks it then passes the workorder object to our recursive search function. If a search string was given
            // that function will check each field in the object, if it is a string it will check if it includes at least part of the supplied search string
            // if it is not a string and it is an array or an object then it recursively calls itself again and goes through each child value.
            // we set our flag if the search string was found for each workorder, if the flag was not set then we mark this workorder not visible
            // For the new repairs column we just apply the deep search method.
            // It queries firestore each call so the data is updated on the webapp when working with the mobile app as well
            setTimeout(() => {
                let filtersApplied = false;
                if (this.searchUnit !== null || this.searchStartDate !== null || this.searchEndDate !== null || this.searchRepairsComplete !== null || this.searchDocumentStatus !== null || this.searchRepairsApproved !== null) {
                    filtersApplied = true
                }
                this.queryWorkOrders(this.searchUnit && this.searchUnit.length > 0 ? this.searchUnit : null, this.searchStartDate, this.searchEndDate, this.searchRepairsComplete && this.searchRepairsComplete.value ? this.searchRepairsComplete.value : null, this.searchRepairsApproved && this.searchRepairsApproved.value ? this.searchRepairsApproved.value : null).then((res) => {
                    let workOrderSearchResults = res.map((item) => {
                        let isVisible = false;
                        let searchResults = {
                            searchKeyFound: false,
                        };

                        // manually check the filters first, if a filter doesn't pass then we can immediately return the work order as not visible
                        if (this.searchRepairsComplete) {
                            if (item.repairsComplete && item.repairsComplete.value !== undefined) {
                                if (item.repairsComplete.value !== this.searchRepairsComplete.value) {
                                    return {
                                        ...item,
                                        isVisible: false
                                    };
                                }
                            }
                        }
                        if (this.searchDocumentStatus) {
                            if (item.documentStatus !== undefined) {
                                if (item.documentStatus !== this.searchDocumentStatus.value) {
                                    return {
                                        ...item,
                                        isVisible: false
                                    };
                                }
                            }
                        }

                        if (this.searchRepairsApproved) {
                            if (item.repairsApproved && item.repairsApproved.value !== undefined) {
                                if (this.searchRepairsApproved.value !== item.repairsApproved.value) {
                                    return {
                                        ...item,
                                        isVisible: false
                                    };
                                }
                                else if (this.searchRepairsApproved.value === false && this.searchRepairsApproved.label === 'Changes Requested' && item.changeNotes && item.changeNotes.length <= 0) {
                                    return {
                                        ...item,
                                        isVisible: false
                                    };
                                }
                                else if (this.searchRepairsApproved.value === false && this.searchRepairsApproved.label === 'Not Submitted' && item.changeNotes && item.changeNotes.length > 0) {
                                    return {
                                        ...item,
                                        isVisible: false
                                    };
                                }
                                else if(this.searchRepairsApproved.label === 'Awaiting Review' && item.changeNotes && item.changeNotes.length > 0){
                                    return {
                                        ...item,
                                        isVisible: false
                                    };
                                }
                                else if(this.searchRepairsApproved.label === 'Resubmitted for Review' && item.changeNotes && item.changeNotes.length === 0){
                                    return {
                                        ...item,
                                        isVisible: false
                                    };
                                }
                            }
                        }
                        // perform the deep search and update local flags
                        if (this.searchKeywords) this.recursiveDeepSearch(item, searchResults);

                        if (this.searchKeywords) {
                            if (searchResults.searchKeyFound) {
                                isVisible = true;
                            }
                        } else {
                            isVisible = true;
                        }

                        return {
                            ...item,
                            isVisible: isVisible
                        };
                    });

                    // add visibility property to each item in repairs array
                    this.queryRepairs(this.searchUnit && this.searchUnit.length > 0 ? this.searchUnit : null, this.searchStartDate, this.searchEndDate).then((res) => {
                        let repairsSearchResults = res.map((item) => {
                            let isVisible = false;
                            let searchResults = {
                                searchKeyFound: false,
                            };

                            // perform the deep search and update local flags
                            if (this.searchKeywords) this.recursiveDeepSearch(item, searchResults);

                            if (this.searchKeywords) {
                                if (searchResults.searchKeyFound) {
                                    isVisible = true;
                                }
                            } else {
                                isVisible = true;
                            }

                            return {
                                ...item,
                                isVisible: isVisible
                            };
                        });

                        this.$emit('filter-data', workOrderSearchResults, repairsSearchResults, filtersApplied);
                        this.searchLoading = false;
                    })
                })
            }, 400)
        },

        recursiveDeepSearch(obj, searchResults) {
            if (lodash.isString(obj) && obj.toLowerCase().includes(this.searchKeywords.toLowerCase())) {
                searchResults.searchKeyFound = true;
            }

            if (lodash.isObject(obj) || lodash.isArray(obj)) {
                lodash.some(obj, (value) => this.recursiveDeepSearch(value, searchResults));
            }
        },

        async queryWorkOrders(unit, startDate, endDate, repairsComplete, repairsApproved) {
            let workOrdersData = [];
            if (startDate === null) {
                startDate = new Date('2020-01-01')
            }
            if (endDate === null) {
                endDate = new Date('2999-01-01')
            }
            let querySnapshot = await getWorkOrdersWithConditions(unit, startDate, endDate, repairsComplete, repairsApproved)
            querySnapshot.forEach((doc) => {
                //check to see if we need to add additional fields to the work order repairs. This is to accomodate past workorders.
                let repairs = this.checkForAdditionalFields(doc.data().repairs);
                let tempWorkOrder = doc.data();
                tempWorkOrder.repairs = repairs;
                tempWorkOrder.isVisible = true;
                //if the work order doesn't have a changeNotes field, add it here.
                if (tempWorkOrder.changeNotes === undefined) {
                    //add the field.
                    tempWorkOrder.changeNotes = [];
                }
                if (tempWorkOrder.datesFormatted) {
                    tempWorkOrder.datesFormatted = false
                }
                if(tempWorkOrder.resubmitNotes === undefined){
                    tempWorkOrder.resubmitNotes = [];
                }
                tempWorkOrder.repairs.forEach((repair, index) => {
                    repair['itemNumber'] = index;
                    repair['addRepairmanVisible'] = false;

                    //add completedBy to each repair if it is not present
                    if (!repair.completedBy) {
                        repair['completedBy'] = { date: null, id: null, name: null };
                    }
                    //turn repairedBy into an array if it is not already
                    if (!Array.isArray(repair.repairedBy)) {
                        repair.repairedBy = [repair.repairedBy];
                    }

                    //add the  newRepairman field
                    repair['newRepairman'] = { name: null, id: null, date: null };
                });

                //add the documentStatus field, and mark what the overall document status for the WO should be
                if (tempWorkOrder.repairs.length > 0) {
                    if (tempWorkOrder.repairs.find((x) => x.documentStatus === null)) {
                        tempWorkOrder['documentStatus'] = null;
                    } else if (tempWorkOrder.repairs.find((x) => x.documentStatus === true) && !tempWorkOrder.repairs.find((x) => x.documentStatus === null)) {
                        tempWorkOrder['documentStatus'] = true;
                    }
                    else {
                        tempWorkOrder['documentStatus'] = false;
                    }
                }

                // remove any units that have been permanently deleted from the user's org
                tempWorkOrder.units = tempWorkOrder.units
                .map((unit) => this.units.find(x => x.UID === unit))
                .filter((unit) => unit !== undefined)
                .map((unit) => unit.UID);

                let index = workOrdersData.push(tempWorkOrder);
                workOrdersData[index - 1]['view'] = doc.id;
            });
            this.convertWorkOrderTimeStampsToJSDates(workOrdersData)
            return workOrdersData
        },

        async queryRepairs(unit, startDate, endDate) {
            let repairsData = []
            if (startDate === null) {
                startDate = new Date('2020-01-01')
            }
            if (endDate === null) {
                endDate = new Date('2999-01-01')
            }
            let querySnapshot = await getWorkOrderRepairsWithConditions(unit, startDate, endDate);

            querySnapshot.forEach((doc) => {
                let data = doc.data();
                data.id = doc.id;
                data.selected = false;
                data.isVisible = true;
                if (data.datesFormatted) {
                    data.datesFormatted = false
                }
                repairsData.push(data);
            });
            repairsData = this.convertRepairsTimeStampsToJSDates(repairsData);
            return repairsData;
        },

        convertWorkOrderTimeStampsToJSDates(workOrders) {
            // convert all timestamps to JS dates from the work orders data retreived from firestore
            workOrders.forEach((wo) => {
                // check if the workorder has had its dates formatted yet
                if (wo.date && wo.date instanceof firestore.Timestamp) {
                    wo.date = wo.date.toDate()
                }
                if (wo.createdDate && wo.createdDate instanceof firestore.Timestamp) {
                    wo.createdDate = wo.createdDate.toDate()
                }
                if (wo.accepted && wo.accepted.time && wo.accepted.time instanceof firestore.Timestamp) {
                    wo.accepted.time = wo.accepted.time.toDate()
                }
                if (wo.repairsApproved && wo.repairsApproved.time && wo.repairsApproved.time instanceof firestore.Timestamp) {
                    wo.repairsApproved.time = wo.repairsApproved.time.toDate()
                }
                if (wo.repairsComplete && wo.repairsComplete.time && wo.repairsComplete.time instanceof firestore.Timestamp) {
                    wo.repairsComplete.time = wo.repairsComplete.time.toDate()
                }
                if (wo.changeNotes.length > 0) {
                    wo.changeNotes.forEach((note) => {
                        if (note.time && note.time instanceof firestore.Timestamp) {
                            note.time = note.time.toDate()
                        }
                    })
                }
                if (wo.resubmitNotes && wo.resubmitNotes.length > 0) {
                    wo.resubmitNotes.forEach((note) => {
                        if (note.time && note.time instanceof firestore.Timestamp) {
                            note.time = note.time.toDate()
                        }
                    })
                }

                if (wo.repairs.length > 0) {
                    wo.repairs.forEach((repair) => {
                        if (repair.date && repair.date instanceof firestore.Timestamp) {
                            repair.date = repair.date.toDate()
                        }
                        if (repair.createdDate && repair.createdDate instanceof firestore.Timestamp) {
                            repair.createdDate = repair.createdDate.toDate()
                        }
                        if (repair.submitted && repair.submitted.time && repair.submitted.time instanceof firestore.Timestamp) {
                            repair.submitted.time = repair.submitted.time.toDate()
                        }
                        if (repair.completedBy && repair.completedBy.date && repair.completedBy.date instanceof firestore.Timestamp) {
                            repair.completedBy.date = repair.completedBy.date.toDate()
                        }
                        if (repair.repairedBy && repair.repairedBy.length > 0) {
                            repair.repairedBy.forEach((repBy) => {
                                if (repBy.date && repBy.date instanceof firestore.Timestamp) {
                                    repBy.date = repBy.date.toDate()
                                }
                            })
                        }
                        if (repair.documents && repair.documents.length > 0) {
                            repair.documents.forEach((doc) => {
                                if (doc.date && doc.date instanceof firestore.Timestamp) {
                                    doc.date = doc.date.toDate()
                                }
                            })
                        }
                    })
                }
            })
            return workOrders;
        },
        convertRepairsTimeStampsToJSDates(repairs) {
            // convert all timestamps to JS dates from the repairs data retreived from firestore
            repairs.forEach((repair) => {
                // check if the repair has had its dates formatted yet
                if (repair.date && repair.date instanceof firestore.Timestamp) {
                    repair.date = repair.date.toDate()
                }
                if (repair.createdDate && repair.createdDate instanceof firestore.Timestamp) {
                    repair.createdDate = repair.createdDate.toDate()
                }
                if (repair.submitted && repair.submitted.time && repair.submitted.time instanceof firestore.Timestamp) {
                    repair.submitted.time = repair.submitted.time.toDate()
                }
                if (repair.completedBy && repair.completedBy.date && repair.completedBy.date instanceof firestore.Timestamp) {
                    repair.completedBy.date = repair.completedBy.date.toDate()
                }
                if (repair.repairedBy && repair.repairedBy.length > 0) {
                    repair.repairedBy.forEach((repBy) => {
                        if (repBy.date && repBy.data instanceof firestore.Timestamp) {
                            repBy.date = repBy.date.toDate()
                        }
                    })
                }
            })
            return repairs;
        },

        checkForAdditionalFields(repairs) {
            //are the repair hours and cost enabled?
            let additionalFieldsFlag = false; //create a flag, so we don't loop the repairs if we don't need to add any additional fields.
            if (this.$store.state.custom.workOrders.repair_hours_enabled) {
                additionalFieldsFlag = true;
            }
            if (this.$store.state.custom.workOrders.repair_cost_enabled) {
                additionalFieldsFlag = true;
            }
            if (this.$store.state.custom.workOrders.labour_hours_enabled) {
                additionalFieldsFlag = true;
            }

            //loop the repairs so we can start adding the new fields.
            if (additionalFieldsFlag) {
                repairs.forEach((repair) => {
                    if (
                        this.$store.state.custom.workOrders.repair_hours_enabled &&
                        repair['repairHours'] == undefined
                    ) {
                        repair.repairHours = null;
                    }
                    if (
                        this.$store.state.custom.workOrders.repair_cost_enabled &&
                        repair['repairCost'] == undefined
                    ) {
                        repair.repairCost = null;
                    }
                    if (
                        this.$store.state.custom.workOrders.labour_hours_enabled &&
                        repair['labourHours'] == undefined
                    ) {
                        repair.labourHours = null;
                    }
                });
            }
            return repairs; //return the repairs, so we can push it to the array.
        },

        clearSearch() {
            let currentDate = new Date()
            let oneYearAgo = new Date(currentDate);
            oneYearAgo.setFullYear(currentDate.getFullYear() - 1);

            this.searchUnit = null;
            this.searchStartDate = oneYearAgo;
            this.searchEndDate = null;
            this.searchKeywords = null;
            this.searchRepairsComplete = null;
            this.searchDocumentStatus = null;
            this.searchRepairsApproved = null;
            this.search();
        }
    },
    computed: {
        activeUnits(){
            return this.units.filter(unit => !unit.dateDeactivated);
        },
    },
    mounted() {
        let currentDate = new Date()
        let oneYearAgo = new Date(currentDate);
        oneYearAgo.setFullYear(currentDate.getFullYear() - 1);

        // check if a work order number was passed as a paramater in the url
        if(this.$route.params.wonumber){
            // if the work order's date is older than 1 year, set the start date to the work order date
            const woDate = new Date(this.$route.params.wodate);
            if (woDate < oneYearAgo) {
                this.searchStartDate = woDate;
            }
            else{
                this.searchStartDate = oneYearAgo;
            }
        }
        else{
            this.searchStartDate = oneYearAgo;
        }
    }
};
</script>
